export default "__VITE_ASSET__BptePbfq__"